module.exports = __webpack_public_path__ + "static/media/00. Pos Bloc New.d54c263b.png";